<template>
  <div class="accidentBox">
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <el-button size="small" type="primary" @click="handleAdd()">新建</el-button>
        <el-radio-group v-model="sourceTypeId" size="small" @change="changeData">
          <el-radio-button label="0">已创建</el-radio-button>
          <el-radio-button label="1">已快报</el-radio-button>
          <el-radio-button label="2">待审批</el-radio-button>
          <el-radio-button label="3">已审批</el-radio-button>
          <el-radio-button label="4">全部</el-radio-button>
        </el-radio-group>
        <Input
          search
          enter-button
          placeholder=" 请输入名称/编号"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px"
        />
      </div>
      <div style="margin-top: 20px;">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="accidentNum" label="编号" width="150">
            <template slot-scope="scope">
              <el-link type="primary" size="mini" @click.native.prevent="showData(scope.row)">
                <span>{{ scope.row.accidentNum }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="departmentVo.name" label="事故部门"></el-table-column>
          <el-table-column prop="place" label="发生地点"></el-table-column>
          <el-table-column prop="occurTime" label="发生时间"></el-table-column>
          <el-table-column prop="accidentReason" label="事故原因">
            <template slot-scope="scope">
              <span v-if="scope.row.accidentReason == 0">人的不安全行为</span>
              <span v-if="scope.row.accidentReason == 1">物的不安全行为</span>
              <span v-if="scope.row.accidentReason == 2">管理上的缺陷</span>
            </template>
          </el-table-column>
          <el-table-column prop="reporterName" label="上报人"></el-table-column>
          <el-table-column prop="jobVo.name" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">已创建</span>
              <span v-if="scope.row.status == 1">已快报</span>
              <span v-if="scope.row.status == 2">待审批</span>
              <span v-if="scope.row.status == 3">已审批</span>
            </template>
          </el-table-column>
          <el-table-column prop="oper" label="操作" width="180">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handChange(scope.row.id,scope.row)">编辑</el-link>|
                <el-link type="danger" @click="handleDel(scope.row.id)">删除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: right">
          <Page :total="total" :page-size="sizePage" @on-change="getData" :current="currentPage" />
        </div>
      </div>
    </div>
    <el-drawer :visible.sync="drawer" :show-close="false" direction="rtl" :before-close="handleClose" size="60%">
      <div slot="title" class="drawerTitle">
        <p>编号：{{ infoForm.accidentNum }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>名称</p><span>{{ infoForm.name }}</span></div>
          <div><p>发生时间</p><span>{{ infoForm.occurTime }}</span></div>
          <div><p>事故部门</p><span v-if="infoForm.departmentVo">{{ infoForm.departmentVo.name }}</span></div>
          <div><p>发生地点</p><span>{{ infoForm.place }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="详情" name="a"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <el-form
            :inline="true"
            :model="infoForm"
            class="demo-form-inline"
            style="background-color: white"
          >
            <el-form-item label="编号：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.accidentNum}}</span>
            </el-form-item>
            <el-form-item label="名称：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.name}}</span>
            </el-form-item>
            <el-form-item label="事故部门：" style="width: 40%;margin-left: 8%">
              <span size="small" v-if="infoForm.departmentVo">{{infoForm.departmentVo.name}}</span>
            </el-form-item>
            <el-form-item label="发生地点：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.place}}</span>
            </el-form-item>
            <el-form-item label="事故原因：" style="width: 40%;margin-left: 8%">
              <el-tag type="success" size="small" v-if="infoForm.accidentReason == '0'">人的不安全行为</el-tag>
              <el-tag type="primary" size="small" v-if="infoForm.accidentReason == '1'">物的不安全行为</el-tag>
              <el-tag type="danger" size="small" v-if="infoForm.accidentReason == '2'">管理上的缺陷</el-tag>
            </el-form-item>
            <el-form-item label="事故原因分析：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.analysis}}</span>
            </el-form-item>
            <el-form-item label="发生时间：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.occurTime}}</span>
            </el-form-item>
            <el-form-item label="上报人：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.reporterName}}</span>
            </el-form-item>
            <el-form-item label="附件：" style="width: 40%;margin-left: 8%">
              <el-link
                v-for="(item1,index) in trainStuff"
                type="primary" :key="index"
                @click="download(item1)"
              >{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>
  </div>
</template>


<script>
import { downLoadDocument } from "@/api/downLoad";
export default {
  data() {
    return {
      activeName: "a",
      infoForm: { departmentVo: { name: "" } },
      drawer: false,
      trainStuff: [
        {
          name: "",
          response: { data: "" }
        }
      ],
      total: 0,
      sizePage: 10,
      currentPage: 1,
      tableData: [],
      sourceTypeId: 4,
      fileNameOrTag: ""
    };
  },
  mounted: function() {
    this.getData(1);
  },
  created() {},
  methods: {
    showData(row) {
      this.trainStuff = [];
      this.infoForm = row;
      let files = JSON.parse(this.infoForm.trainStuff);
      if (files) {
        for (var i = 0; i < files.length; i++) {
          let myFile = {};
          var file = files[i];
          myFile.response = {};
          myFile.response.data = file.url;
          myFile.name = file.fileName;
          this.trainStuff.push(myFile);
        }
      }
      this.drawer = true;
    },
    handleClose() {
      this.drawer = false;
    },
    changeData(val) {
      this.getData(1);
    },
    getData(page) {
      this.currentPage = page;
      let url = "";
      if (this.sourceTypeId == 4) {
        url =
          this.componentsMoudel.getData("urls").getAccidentBulletin +
          "?limit=" +
          this.sizePage +
          "&curPage=" +
          page +
          "&searchParam=" +
          this.fileNameOrTag;
      } else {
        url =
          this.componentsMoudel.getData("urls").getAccidentBulletin +
          "?limit=" +
          this.sizePage +
          "&curPage=" +
          page +
          "&searchParam=" +
          this.fileNameOrTag +
          "&status=" +
          this.sourceTypeId;
      }
      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data;
          // this.currentPage = res.body.page;
          this.total = res.body.cum;
          this.pageTotal = res.body.pageTotal;
        });
    },
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleAdd() {
      this.$router.push({
        path: "addAccidenList"
      });
    },
    handChange(id, row) {
      this.$router.push({
        name: "addAccidenList",
        params: { key: row }
      });
    },
    handleDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander("/accidentBulletin/delete/" + id)
        .openLoad()
        .startPost(this.ruleForm)
        .then(res => {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          if (this.tableData.length <= 1 && this.currentPage > 1) {
            this.currentPage -= 1;
          }
          this.getData(this.currentPage);
        });
    },
    // 下载文件
    download(item) {
      downLoadDocument(item.response.data, item.name)
    }
  }
};
</script>

<style scoped>
.addBtn {
  width: 100px;
  position: absolute;
  top: 10px;
  right: 10px;
}

/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding: 0 15px
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0 15px;
  margin-bottom: 0
}

/* 解决tab切换会有蓝色边框的问题 */ 
.accidentBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
